import { Component, OnDestroy, OnInit } from '@angular/core';
import { JhiAlertService, JhiEventManager } from '../core-utils';
import { Subscription } from 'rxjs';
import { formatErrorList } from './format-error-list';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-alert-error',
    template: `
        <div class="alerts" role="alert">
            <div *ngFor="let alert of alerts"  [ngClass]="{\'alert.position\': true, \'toast\': alert.toast}">
                <ngb-alert *ngIf="alert && alert.type && alert.msg" [type]="alert.type" (close)="alert.close(alerts)">
                    <pre [innerHTML]="alert.msg"></pre>
                </ngb-alert>
            </div>
        </div>`
})
export class JhiAlertErrorComponent implements OnInit, OnDestroy {

    alerts: any[];
    cleanHttpErrorListener: Subscription;
    // tslint:disable-next-line: no-unused-variable
    constructor(private alertService: JhiAlertService,
                private eventManager: JhiEventManager) {
    }

    ngOnInit(): void {
        this.alerts = [];
        this.registerErrorAlertListener();
    }

    registerErrorAlertListener() {
        this.cleanHttpErrorListener = this.eventManager.subscribe('bmsjHipsterApp.httpError', (response) => {
            const httpErrorResponse = response.content;
            switch (httpErrorResponse.status) {
            // connection refused, server not reachable
            case 0:
                this.addErrorAlert('Server not reachable', 'error.server.not.reachable');
                break;
            case 504:
                const msg = `<div class="alert-overflow">
                    <p><strong>ERROR</strong> — The process timed out. Please try again. If the problem persists, contact
                        <a href="mailto:support@integratedbreeding.net">support@integratedbreeding.net</a>.
                    </p>
                </div>`;
                this.alertService.error('error.custom', { param: msg });
                break;
            default:
                this.showErrorMessage(httpErrorResponse);
            }
        });
    };

    ngOnDestroy() {
        if (this.cleanHttpErrorListener !== undefined && this.cleanHttpErrorListener !== null) {
            this.eventManager.destroy(this.cleanHttpErrorListener);
            this.alerts = [];
        }
    }

    addErrorAlert(message, key?, data?) {
        key = (key && key !== null) ? key : message;
        this.alerts.push(
            this.alertService.addAlert(
                {
                    type: 'danger',
                    msg: key,
                    params: data,
                    timeout: 5000,
                    toast: this.alertService.isToast(),
                    scoped: true
                },
                this.alerts
            )
        );
    }

    showErrorMessage(httpErrorResponse: HttpErrorResponse) {
        if (httpErrorResponse.error instanceof Blob) {
            const reader = new FileReader();
            reader.addEventListener('loadend', (e) => {
                const error = JSON.parse(e.srcElement['result']);
                const msg = formatErrorList(error);
                if (msg !== null && msg !== undefined && msg !== '' && msg.length > 0) {
                    this.alertService.error('error.custom', { param: msg });
                } else {
                    this.alertService.error('error.general.client', null, null);
                }
            });
            reader.readAsText(httpErrorResponse.error);
        } else {
            let msg = '';
            if (httpErrorResponse.error !== '' && httpErrorResponse.error.errors) {
                msg = formatErrorList(httpErrorResponse.error.errors);
            } else if (typeof httpErrorResponse.error === 'string') {
                const error = JSON.parse(httpErrorResponse.error);
                msg = formatErrorList(error.errors);
            }
            if (msg !== null && msg !== undefined && msg !== '' && msg.length > 0) {
                this.alertService.error('error.custom', { param: msg });
            } else {
                this.alertService.error('error.general.client', null, null);
            }
        }
    }
}
